import React, { FC } from 'react';
import '../../App.scss';
import styles from './styles.module.scss';

interface IPlayButtonProps {
  onClick: (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => void | Promise<void> | object;
}

const PlayButton: FC<IPlayButtonProps> = ({ onClick }) => {
  const handleClick = (e: any) => onClick(e);

  return <button onClick={handleClick} className={styles.button} />;
};

export default PlayButton;
